<mat-card appearance="outlined" class="mat-elevation-z1">
    <mat-card-title class="header-small" translate="userProfile.installations.title"> </mat-card-title>

    <div class="flex flex-col mt-20px md:mt-30px gap-20px md:gap-30px">
        @if (installationDetails?.meteringPoint) {
            <app-installation-info
                [text]="'userProfile.installations.meteringPointTooltip' | translate"
                [header]="'userProfile.installations.meteringPoint'"
                [body]="installationDetails?.meteringPoint"
            >
            </app-installation-info>
        }

        @if (installationDetails?.installationNumber) {
            <app-installation-info
                [header]="'userProfile.installations.installationNumber'"
                [body]="installationDetails?.installationNumber"
            >
            </app-installation-info>
        }

        @if (installationDetails?.meterNumber) {
            <app-installation-info
                [header]="'userProfile.installations.meterNumber'"
                [body]="installationDetails?.meterNumber"
            >
            </app-installation-info>
        }

        @if (installationDetails?.correctorNumber) {
            <app-installation-info
                [header]="'userProfile.installations.correctorNumber'"
                [body]="installationDetails?.correctorNumber"
            >
            </app-installation-info>
        }

        @if (installationDetails?.gasSupplyStartDate) {
            <app-installation-info
                [header]="'userProfile.installations.gasSupplyEstablished'"
                [body]="
                    'userProfile.installations.gasSupplyEstablishedValue'
                        | translate: { date: installationDetails?.gasSupplyStartDate | date: 'dd. MMMM yyyy' }
                "
            >
            </app-installation-info>
        }

        @if (installationDetails?.displayReadingPlan) {
            <app-installation-info
                [header]="'userProfile.installations.gasMeterReading'"
                [body]="installationDetails?.displayReadingPlan"
            >
            </app-installation-info>
        }

        <!-- Add supplierName if needed -->
        <!-- <app-installation-info [header]="'userProfile.installations.supplierName'"
    [body]="installationDetails?.supplierName">
  </app-installation-info> -->

        <app-installation-info
            [header]="'userProfile.installations.gasLines'"
            [htmlBody]="'userProfile.installations.info'"
        >
        </app-installation-info>
    </div>
</mat-card>
